var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(require(`~/assets/svg/${_vm.brand}/logo.svg?inline`),{tag:"component",staticClass:"logo",attrs:{"aria-labelledby":"logo-title logo-description","role":"img"}})
}
var staticRenderFns = []

export { render, staticRenderFns }